import { render, staticRenderFns } from "./Expediente.vue?vue&type=template&id=4f3e0db8"
import script from "./Expediente.vue?vue&type=script&lang=js"
export * from "./Expediente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f3e0db8')) {
      api.createRecord('4f3e0db8', component.options)
    } else {
      api.reload('4f3e0db8', component.options)
    }
    module.hot.accept("./Expediente.vue?vue&type=template&id=4f3e0db8", function () {
      api.rerender('4f3e0db8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/Expediente.vue"
export default component.exports